import type { PreviewThemeUpdateAction } from '../types/actions'

import { actionFactory } from './factory'

/**
 * Hydrates the journey with the design builder state.
 */
export const previewThemeHydrate = actionFactory<PreviewThemeUpdateAction>(
  (state, { theme, logoUrl, designTokens }) => {
    state.designBuilderState = {
      theme,
      logoUrl,
      designTokens: designTokens || {}
    }
  },
  'previewThemeHydrate'
)
